import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { Address, type AddressConstructorData } from './Address'
import { AddressTypes } from './AddressTypes'

export const AddressConstructorFactory =
  Factory.Sync.makeFactory<AddressConstructorData>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.company.companyName()),
    isActive: true,
    addressType: AddressTypes.GENERAL,
    primaryCategory: null,
    addressLineOne: Factory.each(() => faker.address.streetAddress()),
    addressLineTwo: Factory.each(() => faker.address.streetAddress()),
    city: Factory.each(() => faker.address.city()),
    country: Factory.each(() => faker.address.country()),
    postalCode: Factory.each(() => faker.address.zipCode()),
    stateProvince: Factory.each(() => faker.address.state()),
  })

export const AddressFactory = EntityFactory(Address, AddressConstructorFactory)
